import { ref } from 'vue';
import { promptAuthLogin } from '@/utils/auth-session';

/** 模块级共享：PC / H5 入口共用同一弹窗开关 */
const open = ref(false);

/**
 * 每日签到纯 UI 开关（无 fetch）。
 * @returns {{ open: import('vue').Ref<boolean>, openDialog: () => boolean, closeDialog: () => void }}
 */
export function useDailyCheckInUi() {
  function openDialog() {
    if (!promptAuthLogin()) return false;
    open.value = true;
    return true;
  }

  function closeDialog() {
    open.value = false;
  }

  return {
    open,
    openDialog,
    closeDialog,
  };
}
